import { Clear, FilterAlt } from '@mui/icons-material'
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Menu,
  OutlinedInput,
  Stack,
  Typography,
} from '@mui/material'
import { GetPlacesV2Request } from '@ulysses-inc/harami_api_client'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useListFilter } from 'src/hooks/filter/useListFilter'
import placesOperations from 'src/state/ducks/places/operations'

interface OwnProps {
  request?: GetPlacesV2Request
  updatedPlaces: boolean
  isLoadingPlace?: boolean
  placeGetTrigger?: boolean
  setPlaceGetTrigger: (val: boolean) => void
}

const PlacesFilterDropDown: React.FC<OwnProps> = ({
  request,
  updatedPlaces,
  isLoadingPlace,
  placeGetTrigger,
  setPlaceGetTrigger,
}: OwnProps) => {
  const dispatch = useDispatch()
  const [placeName, setPlaceName] = useState<string>('')
  const { filters, setListFilter } = useListFilter()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const isOpen = anchorEl !== null

  // 絞り込み条件の変更検知して再取得
  useEffect(() => {
    // 更新が完了してない、または取得の必要がなければ場合はリターン
    if (!placeGetTrigger || updatedPlaces || isLoadingPlace) {
      return
    }

    if (!filters || !filters.places || !filters.places.filter) {
      return
    }

    const placeFilter = filters.places.filter
    // eslint-disable-next-line react-hooks/set-state-in-effect -- useEffect内でのsetState呼び出しは既存設計のため、リファクタリング時に修正する
    setPlaceName(placeFilter.placeName ?? '')
    // eslint-disable-next-line react-hooks/immutability -- 関数の宣言順序による既存パターンのため、リファクタリング時に修正する
    getFilterPlaces(placeFilter.placeName)
    setPlaceGetTrigger(!placeGetTrigger)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [placeGetTrigger, updatedPlaces, isLoadingPlace, placeName])

  const isFilterOn = () => {
    return placeName.length > 0
  }

  const clearFilter = () => {
    setPlaceName('')
    saveFilter()
    getFilterPlaces()
  }

  const saveFilter = (placeName?: string) => {
    setListFilter({
      ...(filters ?? {}),
      places: {
        pagination: request,
        filter: {
          placeName: placeName ?? '',
        },
      },
    })
  }

  const getFilterPlaces = (placeName?: string) => {
    const limit = Object.keys(request).length ? request.limit : 25
    placesOperations.getPlacesV2(
      dispatch,
      { limit: limit, offset: 0 },
      { placeName: placeName ? { $like: placeName } : undefined },
    )
  }

  const hoverArea = (
    <Stack>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        <Button onClick={clearFilter}>クリア</Button>
      </Box>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        現場名
      </Typography>
      <OutlinedInput
        fullWidth
        size="small"
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          const newValue = event.target.value
          setPlaceName(newValue)
          saveFilter(newValue)
          getFilterPlaces(newValue)
        }}
        defaultValue={placeName ?? ''}
        value={placeName}
        endAdornment={
          placeName && (
            <InputAdornment position="end" variant="standard">
              <IconButton onClick={clearFilter} size="small" color="default">
                <Clear fontSize="small" />
              </IconButton>
            </InputAdornment>
          )
        }
      />
    </Stack>
  )

  return (
    <Box>
      <Button
        color={isFilterOn() ? 'filtered' : 'secondary'}
        variant="outlined"
        startIcon={<FilterAlt />}
        onClick={({ currentTarget }) => {
          setAnchorEl(currentTarget)
        }}
      >
        絞り込み: {isFilterOn() ? 'ON' : 'OFF'}
      </Button>
      <Menu
        id="member-filter-menu"
        anchorEl={anchorEl}
        open={isOpen}
        onClose={() => {
          setAnchorEl(null)
        }}
        slotProps={{
          paper: {
            sx: {
              padding: 2,
              width: '100%',
              maxWidth: 400,
            },
          },
          list: {
            sx: {
              padding: 0,
            },
          },
        }}
      >
        {hoverArea}
      </Menu>
    </Box>
  )
}

export default PlacesFilterDropDown
